import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonFunctionService, UserMerchantData } from '../Common/common-function.service';
import { VPOSMerchantBoardingFileViewModel } from 'src/app/models/vposmerchant-boarding-file-view-model';
import { VposMerchantSettingsAppView } from 'src/app/models/vpos-merchant-settings-app-view';
import { VposMerchantUserAppView } from 'src/app/models/vpos-merchant-user-app-view';
import { VposUserRoleAppView } from 'src/app/models/vpos-user-role-app-view';
import { VposMerchantAuthenticationAppView } from 'src/app/models/vpos-merchant-authentication-app-view';
import { VposUserAppViewForPermissions } from '../../models/vpos-user-app-view-for-permissions';
import { Vposuserdetailsroleappview } from 'src/app/models/vposuserdetailsroleappview';
import { MerchantSpecificSetting } from 'src/app/models/merchant-specific-setting';
import { PaymentTransaction } from 'src/app/models/payment-transaction';
import { WalletList } from 'src/app/models/wallet-list.model';
import { List } from 'lodash';
import { catchError, map } from 'rxjs';

@Injectable()
export class SettingsService {
  headers: any;
  token: any;
  header: any;
  token1: any;
  constructor(private service: DataService, private http: HttpClient, private common: CommonFunctionService) {


    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));

  }
  GetMerchantSettings() {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposMerchantSettingsAppView>(environment.getMerchantSettingsUrl + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  AddMerchantSettings(data) {
    this.GetHeaderdetails();
    // data.UserId=this.userId;
    return this.http.post(environment.AddMerchantSettingsUrl, data, { headers: this.headers });
  }
  GetMerchantUsersList(merchantKeyId, userType, UserId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposMerchantUserAppView>(environment.getMerchantUsersList + '?MerchantKeyId=' + merchantKeyId + '&UserType=' + userType + '&UserId=' + UserId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }
  GetChargebackFilteredData(MerchantKeyId, paymenttype, fromdate, todate, amount, paymenttransactionid, CaseNumber, status) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetChargebackFilteredData
      + "?MerchantKeyId=" + MerchantKeyId + "&paymenttype=" + paymenttype + "&fromdate=" + fromdate + "&todate=" + todate + "&amount=" + amount + "&paymenttransactionid=" + paymenttransactionid + "&casenumber=" + CaseNumber + "&status=" + status + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  }
  GetReserveFundFilteredData(MerchantKeyId, MerchantBatchId, fromDateTime, toDateTime, ReserveBalance, ReserveAmount, BatchPaymentMethod, symbol) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetReserveFundFilteredData + "?MerchantKeyId=" + MerchantKeyId + "&fromDateTime=" + fromDateTime + "&toDateTime=" + toDateTime + "&ReserveBalance=" + ReserveBalance + "&ReserveAmount=" + ReserveAmount + "&BatchPaymentMethod=" + BatchPaymentMethod + "&symbol=" + symbol + "&MerchantBatchId=" + MerchantBatchId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });
  }
  GetChargeBackMaster(merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetChargeBackMaster + '?merchantKeyId=' + merchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }
  GetReserveFundDataUrl(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetReserveFundDataUrl + '?MerchantKeyId=' + MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });
  }

  GetNotificationList(merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
   return this.http.get<any>(environment.GetGetNotificationList + '?merchantKeyId=' + merchantKeyId+ "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  
}
  GetviewChargeBack(Id, merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetviewChargeBack + "?Id=" + Id + "&merchantKeyId=" + merchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }
  GetChargeBackDetail(MerchantKeyId, ChargeBackMasterId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetChargeBackDetail + "?MerchantKeyId=" + MerchantKeyId + "&ChargeBackMasterId=" + ChargeBackMasterId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }

  InsertDocument(Id, MerchantKeyId, ChargeBackMasterId, data) {
    this.GetHeaderdetails();
    // this.token = environment.GetAuthencticationKey+':'+environment.GetAuthenticationToken+':'+'IT';
    //   const headers = new HttpHeaders(). 
    //   set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.InsertDocument + "?ChargeBackMasterId=" + ChargeBackMasterId + "&Id=" + Id + "&MerchantKeyId=" + MerchantKeyId, data, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));

  }
  viewchargebackdetails(Id, merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.viewchargebackdetails + "?Id=" + Id + "&merchantKeyId=" + merchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }
  SaveChargebackdetails(data, loginUserEmail, ResellerId) {
    // this.token1 = environment.GetAuthencticationKey+':'+environment.GetAuthenticationToken+':'+'IT';
    // const headers = new HttpHeaders(). 
    // set('Authorization', 'basic ' + btoa(this.token1));
    this.GetHeaderdetails();
    return this.http.post<any>(environment.SaveChargebackdetails + "?loginUserEmail=" + loginUserEmail + "&ResellerID=" + ResellerId, data, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  viewUserDetails(emailusername, merchantKeyId, userType) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<Vposuserdetailsroleappview>(environment.viewMerchantUser + '?emailusername=' + emailusername + '&MerchantKeyId=' + merchantKeyId + '&userType=' + userType + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }

  ApproveRejectUser(data, Status) {
    this.GetHeaderdetails();
    return this.http.post(environment.approveRejectUser + '?status=' + Status, data, { headers: this.headers });
  }

  assignRoleToUser(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.assignRoleToUser, data, { headers: this.headers });
  }
  updateUserRole(data) {
    this.GetHeaderdetails();
    return this.http.put(environment.updateUserRole + "?UserId=" + data.UserId, data, { headers: this.headers });
  }

  updateRole(data) {
    this.GetHeaderdetails();
    return this.http.put(environment.updateRole + "?id=" + data.Id, data, { headers: this.headers });
  }
  getSelectedRole(EmailUserName) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposUserRoleAppView>(environment.getSelectedRole + '?emailusername=' + EmailUserName + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }
  CreateRole(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.createNewRole, data, { headers: this.headers });
  }
  getModules(merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposUserAppViewForPermissions>(environment.getModules + '?MerchantKeyId=' + merchantKeyId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  }
  getRoles(merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposUserRoleAppView>(environment.getRoles + '?MerchantKeyId=' + merchantKeyId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  }
  CreateAuthentication(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.createAuthenticationUrl, data, { headers: this.headers });

  }
  // GetAuthenticationDetails(data)
  // {
  //   return this.http.get<VposMerchantAuthenticationAppView>(environment.GetAuthenticationDetails+"?MerchantKeyId="+data).map(response => response) .catch(this.common.handleError);
  // } 
  GetAuthenticationDetails(data) {
    this.GetHeaderdetails();
    let merchantdata: UserMerchantData = this.common.getUserMerchantData();
    const headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.GetAuthenticationDetails + "?LoginUserId=" + merchantdata.UserId, data, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }

  getMerchantSettingsById(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposMerchantSettingsAppView>(environment.getMerchantSettingsByIdUrl + "?MerchantKeyId=" + data+ "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  savepostback(data) {
    this.GetHeaderdetails();
    return this.http.put(environment.updateMerchantSettingspostdataUrl + "?MerchantKeyId=" + data.MerchantKeyId, data, { headers: this.headers });
  }
  getMerchantLogoInfo(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VPOSMerchantBoardingFileViewModel>(environment.getMerchantLogoUrl + "?MerchantKeyId=" + data + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers }).pipe(map(response => response),catchError(this.common.handleError));
  }

  getBoardingKycDatas(merchantkeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VPOSMerchantBoardingFileViewModel>(environment.getMerchantKycDataUrl + "?merchantkeyId=" + merchantkeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers }).pipe(map(response => response),catchError(this.common.handleError));
  }
  updateMerchantSettings(data) {
    this.GetHeaderdetails();
    return this.http.put(environment.updateMerchantSettingsUrl + "?MerchantKeyId=" + data.MerchantKeyId, data, { headers: this.headers });
  }

  uploadFiles(data, MerchantKeyId, filetype) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.post(environment.uploadLogoUrl + '?MerchantKeyId=' + MerchantKeyId + '&filetype=' + filetype + "&LoginUserId=" + merchantdata.UserId, data
      , { headers: this.headers });
  }
  uploadNewDocument(merchantkeyId, fileType, accountType, userEmail, ipAddress, resellerId,AgreementRequestId,GeoLocation,Language,VerificationGeoLocation, data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.post(environment.MerchantDocumentUploadUrl + '?merchantkeyId=' + merchantkeyId + '&fileType=' + 
    fileType + '&accountType=' + accountType + '&userEmail=' + userEmail + '&ipAddress=' + ipAddress + '&resellerId=' + resellerId+
     "&LoginUserId=" + merchantdata.UserId+"&AgreementRequestId="+AgreementRequestId
    +"&UserIpAddress="+ipAddress
    +"&GeoLocation="+GeoLocation
    +"&UpdatedUserName="+merchantdata.UserId
    +"&Language="+Language
    +"&VerificationIPAddress="+ipAddress
    + "&VerificationGeoLocation="+VerificationGeoLocation
    + "&Flag="+0
     , data
      , { headers: this.headers });
  }

  AddMerchantSpecificSettings(data) {
    this.GetHeaderdetails();
    return this.http.post<MerchantSpecificSetting>(environment.AddMerchantSpecificSettings, data, { headers: this.headers });
  }
  StoreSpecificSettings(data) {
    this.GetHeaderdetails();
    return this.http.post<MerchantSpecificSetting>(environment.AddStoreSpecificSettings, data, { headers: this.headers });
  }

  PayOutMerchantSettings(data) {
    this.GetHeaderdetails();
    return this.http.post<MerchantSpecificSetting>(environment.PayOutMerchantSettings, data, { headers: this.headers });
  }

  PayOutCustomerSettings(data) {
    this.GetHeaderdetails();
    return this.http.post<MerchantSpecificSetting>(environment.PayOutCustomerSettings, data, { headers: this.headers });
  }


  AddMerchantMobilenumberSettings(data) {
    this.GetHeaderdetails();
    return this.http.post<MerchantSpecificSetting>(environment.AddMobileMandatoryMerchantSpecificSettings, data, { headers: this.headers });
  }
  MerchantAddressSettings(data) {
    this.GetHeaderdetails();
    return this.http.post<MerchantSpecificSetting>(environment.MerchantAddressSpecificSettings, data, { headers: this.headers });
  }

  MerchantOrderExpirySettings(data) {
    this.GetHeaderdetails();
    return this.http.post<MerchantSpecificSetting>(environment.MerchantOrderExpirySpecificSettings, data, { headers: this.headers });

  }
  MerchantZipCodeSettings(data) {
    this.GetHeaderdetails();
    return this.http.post<MerchantSpecificSetting>(environment.MerchantZipCodeSpecificSettings, data, { headers: this.headers });
  }

  AddPaymentreasonMerchantSettings(data) {
    this.GetHeaderdetails();
    return this.http.post<MerchantSpecificSetting>(environment.AddPaymentMerchantSpecificSettings, data, { headers: this.headers });
  }
  GetMerchantSpecificSettings(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<MerchantSpecificSetting>(environment.getMerchantSpecificSettings + "?AccountId=" + data.AccountId + "&MerchantKeyid=" + data.AccountId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }




  getBankAccountDetails(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getBankAccountDetailsUrl + '?merchantKeyId=' + data+ "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  getBankAccountChangeQueues(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getBankAccountChangeQueues + '?merchantKeyId=' + data + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }

  InserBankaccountdetails(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.AddBankdetails, data, { headers: this.headers });
  }

  checkIfscocdeAccnum(data) {
    this.GetHeaderdetails();
    let merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetIFscCodeandAccountnuber + "?AccountNumber=" + data.AccountNumber + "&IfscCode=" + data.Ifsccode + "&LogInResellerId=" + data.LogInResellerId + "&MerchantKeyId=" + data.MerchantKeyId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }


  GetIfsccodedetails(IfscCode, MerchantKeyid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.GetIfsccodedetails +
        "?IFSCCode=" +
        IfscCode + "&MerchantKeyId=" + MerchantKeyid+ "&LoginUserId="+merchantdata.UserId
        , { headers: this.headers })
        .pipe(map(response => response),catchError(this.common.handleError));

  }

  GetMerchantIpAddressConfigDetails(mid, ipAddressStart, ipAddressEnd, fromdate, todate, source, geoLocation, isApproved) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();

    return this.http.get<any>(environment.GetMerchantIpAddressDetailsUrl + "?merchantKeyId=" + mid +
      "&ipAddressStart=" + ipAddressStart + "&ipAddressEnd=" + ipAddressEnd
      + "&fromdate=" + fromdate + "&todate=" + todate + "&source=" + source + "&geoLocation=" + geoLocation + "&LoginUserId="+merchantdata.UserId + "&isApproved=" + isApproved
      
, { headers: this.headers });
    //.map(response => response) .catch(this.common.handleError);
  }
  SaveMerchantIpAddressDetails(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.InsertMerchantIpAddressConfigDetailsUrl, data, { headers: this.headers });
  }

  GetMerchantIpConfigInfoByKeyId(id) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetMerchantIpAddressConfigById + "?Id=" + id + "&MerchantKeyId=" + merchantdata.MerchantKeyId, { headers: this.headers })
  }

  notificationlistFilterdataurl(MerchantKeyId, fromdate1, todate1, Type) {
    this.GetHeaderdetails();
    return this.http.get<any>(environment.notificationlistFilterdataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + fromdate1 + "&todate=" + todate1 + "&Type=" + Type, { headers: this.headers })

  }


  GetMerchantIpAddressDetailsUrl(merchantKeyId, ipAddressStart, ipAddressEnd, Fromdate1, todate1, source, geoLocation, isapprove, accessType, moduleType) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetMerchantIpAddressDetailsUrl + "?merchantKeyId=" + merchantKeyId + "&ipAddressStart=" + ipAddressStart + "&ipAddressEnd=" + ipAddressEnd + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&source=" + source + "&geoLocation=" + geoLocation + "&LoginUserId="+merchantdata.UserId + "&isApproved=" + isapprove + "&accessType=" + accessType + "&moduleType=" + moduleType
    , { headers: this.headers });
    //.map(response => response) .catch(this.common.handleError);
  }


  GetuserRoleBasedPermissions(userId, appName) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get(environment.getUserRoleBasedPermissions + "?UserId=" + userId + "&AppName=" + appName+"&LoginUserId="+merchantdata.UserId+"&MerchantKeyId="+merchantdata.MerchantKeyId, { headers: this.headers })
  }
  AddMerchantallowTransactionSettings(data) {
    this.GetHeaderdetails();
    return this.http.post<MerchantSpecificSetting>(environment.AddAllowTransactionMerchantSpecificSettings, data, { headers: this.headers });
  }

  VerifyingBankdetails(data) {
    this.GetHeaderdetails();
    let loggedUsername = this.common.getUserName()
    this.token1 = data.MerchantKeyId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post<any>(environment.VerifyingBankdetails, data, { headers: this.headers });
  }
  ValidateBankdetails(data) {
    this.GetHeaderdetails();
    let loggedUsername = this.common.getUserName()
    this.token1 = data.MerchantKeyId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post<any>(environment.ValidateBankdetails, data, { headers: this.headers });
  }
  savebankaccountdetails(data) {
    this.GetHeaderdetails();
    let loggedUsername = this.common.getUserName()
    this.token1 = data.MerchantKeyId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post<any>(environment.savebankaccountdetails, data, { headers: this.headers });
  }
  updatebankaccountdetails(data) {
    this.GetHeaderdetails();
    let loggedUsername = this.common.getUserName()
    this.token1 = data.MerchantKeyId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post<any>(environment.Updatebankacctdetailsurl, data, { headers: this.headers });
  }
  CheckFundBankTransfer(data) {
    this.GetHeaderdetails();
    let loggedUsername = this.common.getUserName()
    this.token1 = data.MerchantKeyId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post<any>(environment.CheckFundBankTransferdetails, data, { headers: this.headers });
  }
  UpdateBankdetailsstatus(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.UpdateBankdetailsstatus, data, { headers: this.headers });
  }
  GetRoleBasedPermissions(role, appName) {
    this.GetHeaderdetails();
    return this.http.get<any>(environment.getRoleBasedPermissions + "?roleName=" + role + "&AppName=" + appName, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }

  GetHeaderdetails() {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));


  }

  GetMerchantWalletDetails(merchantKeyId) {

    var LogInResellerId = this.common.getUserMerchantData().ResellerId;
    return this.http.get<WalletList>(environment.GetMerchantWalletDetailsUrl + "?merchantkeyId=" + merchantKeyId + "&resellerId=" + LogInResellerId, { headers: this.headers });
  }

  GetMerchantServicesAndFeesDetail(merchantKeyId) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    var LogInResellerId = this.common.getUserMerchantData().ResellerId;
    return this.http.get<any>(environment.GetMerchantServicesAndFeesUrl + "?merchantkeyId=" + merchantKeyId + "&resellerId=" + LogInResellerId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  }
  GetMerchantProductServicesAndFeesDetail(merchantKeyId) {
    var LogInResellerId = this.common.getUserMerchantData().ResellerId;
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetMerchantProductServicesAndFeesUrl + "?merchantkeyId=" + merchantKeyId + "&resellerId=" + LogInResellerId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  }

   InsertorUpdatePepDetails(data) {
       this.GetHeaderdetails();
        var LogInResellerId = this.common.getUserMerchantData().ResellerId;
        const merchantdata: UserMerchantData = this.common.getUserMerchantData();
        return this.http.post<any>(environment.InsertorUpdatePepDetailsUrl ,data, { headers: this.headers });
      }
      BusinessProductDescdetails(data) {
        this.GetHeaderdetails();
        var LogInResellerId = this.common.getUserMerchantData().ResellerId;
        const merchantdata: UserMerchantData = this.common.getUserMerchantData();
        return this.http.post<any>(environment.BusinessProductDescdetailsUrl ,data, { headers: this.headers });
      }
      GetPepDetailsandBusinessProddetails(data) {
       this.GetHeaderdetails();
        var LogInResellerId = this.common.getUserMerchantData().ResellerId;
        const merchantdata: UserMerchantData = this.common.getUserMerchantData();
        return this.http.post<any>(environment.GetPepDetailsandBusinessProddetailsUrl,data, { headers: this.headers });
      }

  GetBankList(MerchantKeyid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.GetBankList +
        "?&MerchantKeyId=" + MerchantKeyid+ "&LoginUserId="+merchantdata.UserId
        , { headers: this.headers });
      // .map(response => response).catch(this.common.handleError);

  }
 
  GetPopupGeneralizedMessage(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.GetPopupGeneralizedMessage, data, { headers: this.headers });
  }
 

}

